import TecShow from './TecShow';

export default TecShow;
